import MessageThread from "@/components/feature/MessageThread";
import type { Client } from "../types";

interface Props {
  client: Client;
  tenantId: string;
}

export default function MessagesTab({ client, tenantId }: Props) {
  return (
    <div className="max-w-2xl">
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" style={{ height: "520px" }}>
        <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#C8A96E]/10 text-[#9a7840] font-semibold text-sm shrink-0">
            {client.full_name.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="text-slate-800 text-sm font-medium">{client.full_name}</p>
            <p className="text-slate-400 text-xs">Client conversation</p>
          </div>
          <div className="flex items-center gap-1.5 ml-auto">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
            <span className="text-emerald-600 text-xs font-medium">Live</span>
          </div>
        </div>
        <div className="h-[calc(100%-61px)]">
          <MessageThread
            tenantId={tenantId}
            clientId={client.id}
            senderType="admin"
            clientName={client.full_name}
          />
        </div>
      </div>
    </div>
  );
}